export default {
    xerlot: {
        type: 'users',
        name: 'xerlot'
    },
    trondkla: {
        type: 'users',
        name: 'trondkla'
    },
    binder: {
        type: 'users',
        name: 'fbinder'
    },
    kerpow: {
        type: 'users',
        name: 'kerpow'
    },
    randomx2: {
        type: 'users',
        name: 'randomx2'
    },
    btheben: {
        type: 'users',
        name: 'havukruunu'
    },
    tiagobonamigo: {
        type: 'users',
        name: 'tiagobonamigo'
    },
    jokeres: {
        type: 'users',
        name: 'jokeres'
    },
    sonic: {
        type: 'users',
        name: 'sergej'
    },
    jmdsplotter: {
        type: 'users',
        name: 'jmdsplotter'
    },
    kamio: {
        type: 'users',
        name: 'solomygames'
    },
    los: {
        type: 'users',
        name: 'golgonooza'
    },
    matthew: {
        type: 'users',
        name: 'matthew87'
    },
    chrismbrewer: {
        type: 'users',
        name: 'chrismbrewer'
    },
    svwagpatrons: {
        type: 'groups',
        name: 'svwagpatrons'
    }
}